/* istanbul ignore file */
import React from 'react';

function IconPhone() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "icon-phone",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    style: {
      width: 42
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st-1",
    fill: "#9996CB",
    cx: "21",
    cy: "21",
    r: "21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Rounded",
    transform: "translate(-749.000000, -1263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Communication",
    transform: "translate(100.000000, 1162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "_x2D_Round-_x2F_-Communication-_x2F_-phone",
    transform: "translate(646.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st-2",
    fill: "none",
    points: "11.2,11.2 36,11.2 36,36 11.2,36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_xD83D__xDD39_Icon-Color",
    className: "st-3",
    fill: "#FFFFFF",
    d: "M31.1,27l-3.6-1.6c-0.6-0.1-1.1,0.9-1.5,1.3L25,28.6c-2.9-1.5-5.1-3.7-6.6-6.7l2.2-1.3c0.4-0.4,0.7-1.1,0.6-1.7l-1-2.8c-0.7-1.2-0.7-2.4-1.8-2.4l-2.1,0.6c-1.2,0.4-2.1,1-2.1,2.1c0.5,8.8,7.6,15.9,16.4,16.4c1.2,0.1,1.6-0.7,2.1-2.1l0.8-2C33.7,27.9,31.6,27.1,31.1,27z"
  }))))));
}

export default IconPhone;